import type { TokenMetaOutput, ChainMetaOutput, WalletBalance } from "~/api/types";
import { formatAmount } from "~/lib/format";

function truncateAddress(addr: string) {
  if (addr.length <= 10) return addr;
  return `${addr.slice(0, 6)}...${addr.slice(-4)}`;
}

export function TokenRow({
  token,
  chain,
  balance,
  onClick,
}: {
  token: TokenMetaOutput;
  chain?: ChainMetaOutput;
  balance?: WalletBalance;
  onClick: () => void;
}) {
  return (
    <button
      onClick={onClick}
      className="flex h-[60px] items-center gap-3 rounded-[var(--radius-sm)] px-3 py-0 text-left transition-colors hover:bg-[rgba(246,246,246,0.08)]"
    >
      {/* Token icon with chain badge */}
      <div className="relative h-8 w-8 shrink-0">
        {token.logoUri ? (
          <img
            src={token.logoUri}
            alt={token.symbol}
            className="h-8 w-8 rounded-full"
          />
        ) : (
          <div className="flex h-8 w-8 items-center justify-center rounded-full bg-[var(--color-bg-modal-input)] text-xs font-bold text-[#9b9b9b]">
            {token.symbol.slice(0, 2)}
          </div>
        )}
        {chain?.logoUri && (
          <div className="absolute right-0 bottom-0 h-4 w-4 overflow-hidden rounded-[4px] border border-[var(--color-bg-modal)] bg-[var(--color-bg-modal)]">
            <img
              src={chain.logoUri}
              alt={chain.name}
              className="h-full w-full rounded-[4px]"
            />
          </div>
        )}
      </div>

      <div className="min-w-0 flex-1">
        <p className="text-sm font-bold text-[var(--color-text-primary)]">
          {token.symbol}
        </p>
        <p className="truncate text-xs text-[#9b9b9b]">
          {chain?.name ?? ""}{" "}
          <span className="text-[#6b6b6b]">
            {truncateAddress(token.address)}
          </span>
        </p>
      </div>

      {balance && (
        <div className="ml-auto shrink-0 text-right">
          <p className="text-sm font-medium text-[var(--color-text-primary)]">
            ${balance.valueUsd.toFixed(2)}
          </p>
          <p className="text-xs text-[#9b9b9b]">
            {formatAmount(balance.amount, balance.decimals)}
          </p>
        </div>
      )}
    </button>
  );
}
